import React from 'react'
import { Form, Select } from '@surecompanies/core_components'
import {
  FieldsGrid,
  FieldGroup,
} from '../../PaymentDetailModal/PaymentDetailModal.styles'
import {
  StatusUpdateFormKey,
  StatusUpdateFormKeyLabels,
} from '../statusUpdate.type'
import { TicketField } from './TicketField'

export function ContactEvidenceFields() {
  return (
    <div style={{ marginTop: '16px' }}>
      <FieldsGrid>
        <TicketField />

        <FieldGroup>
          <Form.Item
            name={StatusUpdateFormKey.EE_CONTACT}
            label={StatusUpdateFormKeyLabels[StatusUpdateFormKey.EE_CONTACT]}
            rules={[
              {
                required: true,
                message: `${StatusUpdateFormKeyLabels[StatusUpdateFormKey.EE_CONTACT]} is required`,
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <Select placeholder="Select" style={{ width: '100%' }}>
              <Select.Option value={true}>Yes</Select.Option>
              <Select.Option value={false}>No</Select.Option>
            </Select>
          </Form.Item>
        </FieldGroup>

        <FieldGroup>
          <Form.Item
            name={StatusUpdateFormKey.HR_CONTACT}
            label={StatusUpdateFormKeyLabels[StatusUpdateFormKey.HR_CONTACT]}
            rules={[
              {
                required: true,
                message: `${StatusUpdateFormKeyLabels[StatusUpdateFormKey.HR_CONTACT]} is required`,
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <Select placeholder="Select" style={{ width: '100%' }}>
              <Select.Option value={true}>Yes</Select.Option>
              <Select.Option value={false}>No</Select.Option>
            </Select>
          </Form.Item>
        </FieldGroup>
      </FieldsGrid>
    </div>
  )
}
